import { render, staticRenderFns } from "./notification-badge.vue?vue&type=template&id=077966d2&"
import script from "./notification-badge.vue?vue&type=script&lang=js&"
export * from "./notification-badge.vue?vue&type=script&lang=js&"
import style0 from "./notification-badge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Applications/MAMP/htdocs/ai-contact/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('077966d2')) {
      api.createRecord('077966d2', component.options)
    } else {
      api.reload('077966d2', component.options)
    }
    module.hot.accept("./notification-badge.vue?vue&type=template&id=077966d2&", function () {
      api.rerender('077966d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LayoutComponents/Menu/notification-badge.vue"
export default component.exports